export type SpacingType = {
  readonly XS: string,
  readonly SM: string,
  readonly SMMD: string,
  readonly MD: string,
  readonly MDLG: string,
  readonly LG: string,
  readonly XL: string,
  readonly XXL: string,
  readonly XXXL: string,
};

export const SPACING: SpacingType = Object.freeze({
  XS: '4px',
  SM: '8px',
  SMMD: '12px',
  MD: '16px',
  MDLG: '20px',
  LG: '24px',
  XL: '32px',
  XXL: '40px',
  XXXL: '48px',
});
